<template>
  <nav class="navbar header-navbar align-items-center navbar-light navbar-expand">
    <div class="navbar-container d-flex content">
      <div class="bookmark-wrapper d-flex align-items-center">
        <!-- sm以下, 展開右側滑動選單 -->
        <ul v-if=" props.isMinimal " class="nav navbar-nav d-xl-none">
          <!-- 打開左側選單 -->
          <li @click="setOverlay(!isOverlay)"
              class="nav-item">
            <a class="d-flex align-items-center justify-content-center nav-link menu-toggle is-active">
              <icon-sax type="menu" />
            </a>
          </li>
        </ul>
        <!-- 切換系統選單 -->
        <j-menu-portal />
        <!-- 麵包屑 - 路徑導覽 -->
        <j-breadcrumb class="d-none d-md-flex" />
      </div>
    </div>
  </nav>
</template>

<script setup>

import IconSax from "@/component/IconSax.vue"
import JBreadcrumb from "@/component/Breadcrumb.vue"

import JMenuPortal from "@/component/menu/horizontal/item/HorizontalMenuPortal.vue"


import {useMenu} from "@/hook/useMenu"

const {
  isOverlay,
  setOverlay
} = useMenu()

const props = defineProps({
    isMinimal: { type: Boolean, required: false, default: false }
  })

</script>

<style scoped lang="scss">
// 簡化後 header 只留系統切換 + 麵包屑:
// 1. 高度縮到剛好包住兩者  2. 透明背景 (去掉 #283046 深色塊)、無陰影/圓角
// 3. 不再固定 (floating-nav 已移除), 改由 content-body 內文件流承載, 隨捲軸捲動
.header-navbar {
  // min-height 0: 讓高度由麵包屑/切換器內容決定, 上下不再多留空隙
  min-height: 0;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  .navbar-container {
    padding: 0.2rem 1rem;

  }
}
.bookmark-wrapper {
  // 允許左半區收縮（flex item 預設 min-width:auto 會撐住不縮）
  min-width: 0;
  // 漢堡 toggle 與 portal 切換器根節點不參與收縮（scoped 可及子元件根 ul）
  > ul.nav {
    flex-shrink: 0;

  }
}
</style>
